import React from 'react';
import styles from './PromoBanner.scss';

export default function PromoBanner() {

	return (
		<>
			<div className={styles.promo}>
				<a href={'/web-hosting-promo.php'} className={styles.backgroundImg}></a>
			</div>
		</>
	)

}
